export const parseDateInput = (value: any, multiple?: boolean) => {
  if (Array.isArray(value)) {
    // eslint-disable-next-line no-nested-ternary
    return value.length > 1 ? value : multiple ? value : value[0];
  }
  return value;
};
